import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSessionExpired: false,
  accessToken: null,
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionExpired: (state, action) => {
      state.isSessionExpired = action.payload;
    },
    updateAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    clearSession: (state) => {
      state.isSessionExpired = false;
      state.accessToken = null;
    },
  },
});

export const { setSessionExpired, updateAccessToken, clearSession } = sessionSlice.actions;

export default sessionSlice.reducer;
